/**
 * created by tianruojun
 * 编辑器表单布局配置项
 * 每行总宽24
 */
export const informationConfig = {
    default:24,
    summary:24,
    author:12,
    phone:12,
    photography:12,
    camera:12,
    editor:12,
};